import { EMPTY, from, Observable, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Loginservices } from '../login/login.services';
import Swal from 'sweetalert2';
import { Utilityservice } from '../views/utility/utilityservice.service';
 
@Injectable()
export class AppHttpIntercepter implements HttpInterceptor {
    constructor(private _router: Router,private loginservice:Loginservices,private utilityservice:Utilityservice) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.endsWith('/login') || request.url.endsWith('/checkorginitial')|| request.url.endsWith('/sendtraininginvite') ||request.url.includes('/generic/logout') || request.url.includes('/verifymfaotp') || request.url.includes('/resetpassword') ||  request.url.includes('/changepassword') || request.url.includes('/getadmindetailsforcontact') || request.url.includes('/traininglink') || request.url.includes('/trainingmsg') ||request.url.includes('/audit/generic/logout') || request.url.includes('/support') || request.url.includes('/forgotpassword') || request.url.includes('/verifylink')|| request.url.includes('/verifyotppwd') || request.url.includes('/sendotpforpassword') || request.url.includes('/gen_webservice_sso_client_oberoi' ) || request.url.includes('/session')) {            
            return next.handle(request);
        }
        const userdata = this.loginservice.getLoggeduser();
        const authReq = request.clone({
            setHeaders: {
              authtoken: `${userdata.token}`
            }
          });
          return next.handle(authReq).pipe(
            tap((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                const body = event.body;
                let responseStatus: string | undefined;
                // Handling both array and non-array responses safely
                if (Array.isArray(body)) {
                  responseStatus = body[0]?.response;
                } else if (body && typeof body === 'object') {
                  responseStatus = body.response;
                }
                
                if (responseStatus=== 'expired'|| responseStatus === 'invalid') {
           Swal.fire({
              icon: "info",
              title: "Login required",
              text: 'Your session has expired. Please log in again to continue.',
            }).then((result)=>{
              if(result.isConfirmed){
                 this.utilityservice.logoutAndRedirect();
              }
            });                
                }
              }
            }),
            catchError((error: HttpErrorResponse) => {

              if (error.error?.response === 'html') {
    return from(
      Swal.fire( "The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.","","error")
    ).pipe(
      concatMap(() => EMPTY)
    );
  }
              if (error.status === 401) {
               this.utilityservice.logoutAndRedirect();
              }
              return throwError(() => error);
            })
          );
        }
   
}